import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 9,
  path: '/emergencyManagement',
  component: Home,
  redirect: '/emergencyManagement/emergencyList/energencyMaterials',
  name: 'emergencyManagement',
  isHead: true,
  meta: {
    title: '应急管理',
    img: require('@/assets/img/yjgl.png')
  },
  children: [
    {
      path: 'emergencyList',
      component: () => import('@/views/emergencyManagement/index'),
      name: 'emergencyManagement',
      meta: { title: '应急管理', close: false },
      children: [
        {
          path: 'energencyMaterials',
          component: () => import('@/views/emergencyManagement/energencyMaterials/index'),
          name: 'energencyMaterials',
          meta: { title: '企业应急预案管理', next: '/emergencyManagement/emergencyList/energencyDrill', close: false}
        }, {
          path: 'energencyDrill',
          component: () => import('@/views/emergencyManagement/energencyDrill/index'),
          name: 'energencyDrill',
          meta: { title: '企业应急物资管理', next: '/emergencyManagement/emergencyList/energencyPreplan', close: false}
        }, {
          path: 'energencyPreplan',
          component: () => import('@/views/emergencyManagement/energencyPreplan/index'),
          name: 'Preplan',
          meta: { title: '企业应急演练管理', next: '/emergencyManagement/emergencyList/energencyMaterials', close: false}
        }
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/emergencyManagement.js